import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import Cookies from 'js-cookie'

export const defaultHeaders = {
  'X-CSRFToken': Cookies.get('csrftoken'),
}

const emailRegex = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/

export function validateEmail(email) {
  if (typeof email !== 'string') {
    return false
  }
  return email.search(emailRegex) !== -1
}

export function formatDate(dateISOString, dateFormat) {
  return format(parseISO(dateISOString), dateFormat)
}

export function formatNumber(number) {
  if (typeof number === 'number' && !Number.isNaN(number)) {
    return (number + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  return '0'
}
